module.exports = __webpack_public_path__ + "static/media/volunteer_import.a6ceff37.svg";